export default {"src":"/_next/static/media/c_Bronze_1.14988ff6.svg","height":92,"width":87,"blurWidth":0,"blurHeight":0};